var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 94,
    viewBox: "0 0 341 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2553_12117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: -244,
    width: 360,
    height: 361
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 -243.5H9.53674e-07C-6.62742 -243.5 -12 -238.127 -12 -231.5V104.5C-12 111.127 -6.62741 116.5 1.04904e-05 116.5H336C342.627 116.5 348 111.127 348 104.5V-231.5C348 -238.127 342.627 -243.5 336 -243.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2553_12117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.858 -5.32892C413.856 -5.32892 413.855 -5.32733 413.855 -5.32536L413.724 1.73727C413.65 5.77354 410.255 8.91424 406.231 9.23879C365.492 12.5246 336.444 56.5299 303.468 95.5323C270.528 134.491 215.963 143.88 173.54 117.15C141.288 96.8283 99.049 83.6667 42.619 96.5979C-34.8059 114.351 -75.4431 77.1854 -84.2967 67.7383C-85.5455 66.4059 -86.1417 64.6292 -86.108 62.8034C-85.9758 55.6434 -76.1728 51.3475 -70.1338 55.1964C-51.0443 67.3629 -14.3047 82.6627 40.8334 71.9055C94.657 61.4079 135.873 74.6199 167.319 96.6051C211.448 127.457 263.94 112.125 298.64 73.7343C311.485 59.4999 323.412 44.3475 337.193 33.8355C364.805 12.7647 387.481 -6.39092 413.858 -5.32892Z",
    fill: "url(#paint0_linear_2553_12117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.389 -34.3203C414.391 -34.3203 414.392 -34.3187 414.392 -34.3167L414.259 -27.0747C414.186 -23.0856 410.83 -19.9832 406.87 -19.4949C385.852 -16.9026 365.448 -0.146797 335.009 15.2553C319.86 22.9197 307.256 37.9029 293.814 51.8889C257.346 89.7069 206.895 111.116 161.092 76.0053C130.41 52.4902 90.2409 39.0621 39.0453 47.1549C-30.3765 58.1276 -71.1602 31.2516 -82.2325 22.5637C-84.2579 20.9745 -85.2934 18.4998 -85.246 15.9257C-85.1049 8.2559 -75.6583 3.35663 -68.7805 6.75385C-49.6322 16.2118 -13.7324 28.3709 37.2597 22.3725C85.8093 16.6629 124.894 30.4293 154.861 55.3773C202.294 94.8621 250.754 67.2537 288.983 30.0081C303.026 16.2633 316.609 1.74451 332.823 -3.36028C373.658 -16.2159 393.289 -35.1663 414.389 -34.3203Z",
    fill: "url(#paint1_linear_2553_12117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.928 -63.4419C414.927 -63.4412 414.927 -63.4403 414.927 -63.4393L414.851 -59.3144C414.747 -53.5788 409.858 -49.0256 404.358 -47.395C388.711 -42.7559 369.839 -28.4696 330.644 -22.0085C313.482 -19.1753 298.798 -5.40884 284.16 8.08755C244.168 44.7644 197.642 78.6799 148.646 34.7059C119.342 8.40794 81.3725 -5.81925 35.4796 -2.44605C-25.899 2.06165 -66.0591 -15.7756 -79.4907 -22.9722C-82.6674 -24.6743 -84.4288 -28.04 -84.3627 -31.6434C-84.2182 -39.5201 -75.6347 -44.8827 -68.2122 -42.2427C-49.2241 -35.4891 -13.9039 -26.1187 33.6904 -27.3005C76.9084 -28.3697 113.729 -13.5809 142.418 14.0059C192.908 62.5627 237.576 22.2355 279.333 -13.8653C294.572 -27.1133 310.358 -39.9256 328.462 -40.6924C383.726 -43.0248 399.099 -64.0704 414.925 -63.4484C414.929 -63.4483 414.93 -63.4443 414.928 -63.4419Z",
    fill: "url(#paint2_linear_2553_12117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.464 -92.6656L415.42 -90.3063C415.296 -83.5771 409.645 -77.4103 403.634 -74.3836C391.343 -68.1952 371.948 -56.6117 326.274 -59.3908C307.169 -60.5572 290.342 -48.8356 274.499 -35.836C230.975 -0.304024 188.088 46.514 136.19 -6.71204C108.074 -35.548 72.4308 -50.9992 31.8984 -52.1728C-21.5372 -53.72 -60.2526 -64.1628 -75.9309 -69.1537C-80.6073 -70.6423 -83.5727 -75.057 -83.4821 -79.9637C-83.3422 -87.5382 -76.167 -93.0846 -68.755 -91.5176C-50.1967 -87.5941 -14.9414 -81.0658 30.1128 -77.0668C67.9596 -73.7044 102.386 -57.5008 129.966 -27.4552C183.196 30.5156 224.394 -22.8652 269.675 -57.8284C286.116 -70.5796 303.922 -81.124 324.092 -78.1144C393.331 -67.78 404.913 -93.0847 415.46 -92.6622C415.462 -92.6621 415.464 -92.6637 415.464 -92.6656Z",
    fill: "url(#paint3_linear_2553_12117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.913 -117.078C415.912 -117.079 415.911 -117.078 415.911 -117.077L415.778 -109.804C415.746 -108.062 414.25 -106.554 412.737 -105.689C404.542 -101.006 388.876 -81.0554 321.894 -96.1819C300.578 -100.999 281.872 -91.671 264.833 -79.1682C217.785 -44.7774 178.196 15.2453 123.724 -47.5423C96.6451 -78.7651 63.4747 -95.8255 28.3171 -101.301C-19.6168 -108.772 -57.4046 -113.859 -73.8508 -116.005C-78.9499 -116.67 -82.7253 -121.054 -82.6309 -126.196C-82.5309 -131.642 -78.1324 -135.978 -72.6889 -135.764C-55.8158 -135.102 -18.6367 -132.465 26.4559 -122.03C58.9495 -114.506 90.8095 -96.5022 117.428 -64.113C173.052 3.55257 211.118 -63.1662 259.93 -96.9882C277.57 -109.246 297.111 -117.332 319.64 -110.733C402.005 -86.6062 410.634 -117.279 415.912 -117.076C415.913 -117.076 415.914 -117.077 415.913 -117.078Z",
    fill: "url(#paint4_linear_2553_12117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.252 -135.89C416.253 -135.891 416.255 -135.891 416.255 -135.889L416.136 -129.435C416.108 -127.974 415.181 -126.036 414.308 -124.863C409.372 -118.234 392.675 -98.0128 317.36 -124.528C293.567 -132.909 273.245 -126.065 255.004 -114.056C204.435 -80.8027 167.798 -7.33749 111.105 -79.9279C84.915 -113.462 54.4446 -132.499 24.5718 -141.992C-17.6886 -155.429 -54.2364 -155.794 -71.5112 -154.928C-77.0989 -154.648 -82.0323 -159.116 -81.9299 -164.71C-81.8557 -168.764 -79.1471 -172.242 -75.1518 -172.935C-50.4606 -177.219 37.9425 -185.049 104.78 -95.1631C183.217 10.3241 220.25 -176.116 315.077 -137.751C409.889 -99.3853 416.25 -135.877 416.252 -135.89C416.252 -135.89 416.252 -135.89 416.252 -135.89Z",
    fill: "url(#paint5_linear_2553_12117)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2553_12117",
    x1: -86.1602,
    y1: 63.4851,
    x2: 413.855,
    y2: 63.4851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2553_12117",
    x1: -85.3203,
    y1: 29.7381,
    x2: 414.392,
    y2: 29.7381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2553_12117",
    x1: -84.476,
    y1: -3.97966,
    x2: 414.927,
    y2: -3.97966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2553_12117",
    x1: -83.6328,
    y1: -38.752,
    x2: 415.464,
    y2: -38.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2553_12117",
    x1: -82.7969,
    y1: -78.0558,
    x2: 415.911,
    y2: -78.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2553_12117",
    x1: -82.1214,
    y1: -112.108,
    x2: 416.255,
    y2: -112.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBg);
export default __webpack_public_path__ + "static/media/packageBg.27789b22eaad61daf7c078af1e35413b.svg";
export { ForwardRef as ReactComponent };